import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CreatableSelect from "react-select/creatable";
import { skillsdata } from "../../data/skillsdata";
import Message from "../../components/Message";
import Login from "../Login";
import Api from "../../Api";
import "../../styles/requestdetails.css";
import collaboration from "../../assets/collaboration.svg";
import { buildEmployer, hireEmployer } from "../../actions/employerAction";
import { Upload, message } from "antd";
import { InboxOutlined } from "@ant-design/icons";

const { Dragger } = Upload;

const props = {
  name: "file",
  multiple: false,
  action: "https://api.cloudinary.com/v1_1/teqporte/upload",
  onChange(info) {
    const { status } = info.file;
    if (status !== "uploading") {
      console.log(info.file, info.fileList);
    }
    if (status === "done") {
      message.success(`${info.file.name} file uploaded successfully.`);
    } else if (status === "error") {
      message.error(`${info.file.name} file upload failed.`);
    }
  },
};

const EmployerDetailsRequest = ({ history }) => {
  const [selectValue, setSelectValue] = useState("");
  const [title, setTitle] = useState("");
  const [details, setDetails] = useState("");
  const [skill, setSkill] = useState("");
  const [file, setFile] = useState("");
  const [budget, setBudget] = useState(0);
  const [company, setCompany] = useState("");
  const [country, setCountry] = useState("");
  const [employeesnumber, setEmployeesNumber] = useState("");
  const [skillrequest, setSkillRequest] = useState("");
  const [otherdetails, setOtherDetails] = useState("");
  const [uploading, setUploading] = useState(false);
  const [messages, setMessage] = useState("");

  const [fileList, setFileList] = useState([]);
  const [cloudList, setCloudList] = useState([]);

  const dispatch = useDispatch();

  const userLogin = useSelector((state) => state.userLogin);

  const employerBuildState = useSelector((state) => state.employerBuild);

  const { loading, error, employerBuild } = employerBuildState;

  const { userInfo } = userLogin;

  const hireEmployerState = useSelector((state) => state.employerHire);

  const { hireloading, hireerror, employerHire } = hireEmployerState;

  if (!userInfo && !userInfo.role) {
    return <Login />;
  }

  if (userInfo && userInfo.role === "developer") {
    history.push("/developer/dashboard");
  }

  // useEffect(() => {
  //   if (!userInfo) {
  //     history.push("/login");
  //   }
  // }, [history, userInfo]);

  const handleChange = (info) => {
    let fileList = [...info.fileList];

    // 1. Limit the number of uploaded files
    // Only to show one recent uploaded file, and old ones will be replaced by the new
    fileList = fileList.slice(-1);

    // 2. Read from response and show file link
    fileList = fileList.map((file) => {
      if (file.response) {
        // Component will show file.url as link
        file.url = file.response.url;
      }
      return file;
    });

    setFileList(fileList);
  };

  const dummyRequest = ({ file, onSuccess }) => {
    const image = new FormData();
    image.append("upload_preset", "fz0bvgt7");
    image.append("file", file);
    const config = {
      headers: { "X-Requested-With": "XMLHttpRequest" },
    };
    axios
      .post("https://api.cloudinary.com/v1_1/teqporte/upload", image, config)
      .then((res) => {
        const secureUrl = res.data.secure_url;
        const newList = [secureUrl];
        setCloudList(newList);
        setFile(newList);
      });
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

  console.log(cloudList);
  console.log(fileList);

  const handleSelect = (newValue, actionMeta) => {
    let skillArr = newValue.map((item) => {
      return item.value;
    });
    setSkill(skillArr);
    setSkillRequest(skillArr);
  };

  const buildSubmit = (e) => {
    e.preventDefault();
    if (!skill.length) {
      return message.error("Skill field is required");
    }
    if (fileList === []) {
      setFile([]);
    }
    dispatch(buildEmployer(title, details, skill, file, budget, history));
  };

  const hireSubmit = (e) => {
    e.preventDefault();
    if (!skillrequest.length) {
      return message.error("Skill field is required");
    }
    dispatch(
      hireEmployer(
        company,
        country,
        employeesnumber,
        skillrequest,
        otherdetails,
        history
      )
    );
  };

  return (
    <div className="request">
      {error && <Message variant="danger">{error}</Message>}
      {hireerror && <Message variant="danger">{hireerror}</Message>}
      <div className="left">
        <div>
          <div className="logo" href="/">
            wedevelopers
          </div>
        </div>
        <div>
          <h4 className="font-subhead lh-small mt-4 my-2">
            Hire the best developers
          </h4>
          <p className="font-normal">
            Hire top pre-vetted software engineers to build your product
          </p>
        </div>
        <div className="mt-2">
          <img
            className="w-100"
            src={collaboration}
            alt="collaboration illustration"
          />
        </div>
      </div>
      <div className="right">
        <div className="text-right p-2">
          <Link
            style={{ textDecoration: "underline" }}
            to="/employer/dashboard">
            go to dashboard
          </Link>
        </div>
        <div className="text-center logo-sm mt-2">
          <a className="logo" href="/">
            wedevelopers
          </a>
        </div>
        <div className="form-wrapper">
          <h3 className="lh-small font-subhead mt-4 mb-50">
            Make a request on wedevelopers.
          </h3>
          <p className="mb-2">Tell us what you need done.</p>
          <div className="w-100">
            <div>
              <select
                className="select mb-2"
                onChange={(e) => {
                  setSelectValue(e.target.value);
                }}>
                <option value="">What do you want to do?</option>
                <option value="build">Build a product</option>
                <option value="hire">Hire developer for your team</option>
              </select>
            </div>
            {selectValue === "build" && (
              <form onSubmit={buildSubmit}>
                <div className="mb-1">
                  <label className="mb-25 d-inline-block font-weight-bolder">
                    Give your job a title
                  </label>
                  <div className="input">
                    <input
                      type="text"
                      placeholder="Develop a web app for ecommerce"
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                      required
                    />
                  </div>
                </div>
                <div className="">
                  <label className="mb-25 d-inline-block font-weight-bolder">
                    Describe the job in details
                  </label>
                  <div className="input">
                    <p className="mb-25">
                      Include requirements and time frame for delivery
                    </p>
                    <textarea
                      rows="10"
                      value={details}
                      onChange={(e) => setDetails(e.target.value)}
                      required></textarea>
                  </div>
                </div>
                {/* <div className="mb-1">
                  <label className="my-25 d-inline-block font-weight-bolder">
                    include .doc or .pdf file(if available)
                  </label>
                  <Dragger
                    fileList={fileList}
                    onChange={handleChange}
                    customRequest={dummyRequest}>
                    <p>
                      <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">
                      Click or drag file to this area to upload
                    </p>
                  </Dragger>
                </div> */}
                <div className="mb-1">
                  <label className="my-25 d-inline-block font-weight-bolder">
                    include .doc or .pdf file(if available)
                  </label>
                  <Dragger
                    fileList={fileList}
                    onChange={handleChange}
                    customRequest={dummyRequest}>
                    <p>
                      <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">
                      Click or drag file to this area to upload
                    </p>
                  </Dragger>
                </div>
                <div className="mb-1">
                  <label className="mb-25 d-inline-block font-weight-bolder">
                    What skills are required
                  </label>
                  <div className="input">
                    <p className="mb-25">
                      Enter up to 3 skills that best describe your project.
                      Developers will use these skills to find projects they are
                      most interested and experienced in.
                    </p>
                    <CreatableSelect
                      isMulti
                      name="skill"
                      options={skillsdata}
                      onChange={handleSelect}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      required
                    />
                  </div>
                </div>
                <div className="mb-1">
                  <label className="mb-25 d-inline-block font-weight-bolder">
                    Budjet Offer(in USD)
                  </label>
                  <div className="input">
                    <input
                      type="number"
                      placeholder="10000"
                      onChange={(e) => setBudget(e.target.value)}
                      required
                    />
                  </div>
                </div>
                <div className="my-2">
                  <button
                    className="d-flex justify-content-center button"
                    type="submit">
                    {loading ? <div className="spinner"></div> : "SUBMIT"}
                  </button>
                </div>
              </form>
            )}

            {selectValue === "hire" && (
              <form onSubmit={hireSubmit}>
                <p className="mb-1">
                  We take great pride in matching our developers with the best
                  partners. Tell us about your team below!
                </p>
                <div className="mb-1">
                  <label className="mb-25 d-inline-block font-weight-bolder">
                    Name of company
                  </label>
                  <div className="input">
                    <input
                      type="text"
                      placeholder="Enter company name"
                      onChange={(e) => setCompany(e.target.value)}
                      required
                    />
                  </div>
                </div>
                <div className="mb-1">
                  <label className="mb-25 d-inline-block font-weight-bolder">
                    Where is the Company established
                  </label>
                  <div className="input">
                    <input
                      type="text"
                      name="country"
                      placeholder="e.g. Germany"
                      onChange={(e) => setCountry(e.target.value)}
                      required
                    />
                  </div>
                </div>
                <div className="mb-1">
                  <label className="mb-25 d-inline-block font-weight-bolder">
                    Number of employees you plan on employing
                  </label>
                  <div className="input">
                    <input
                      type="number"
                      name="noe"
                      placeholder="e.g. 20"
                      onChange={(e) => setEmployeesNumber(e.target.value)}
                      required
                    />
                  </div>
                </div>
                <div className="mb-1">
                  <label className="mb-25 d-inline-block font-weight-bolder">
                    What skills are you looking for
                  </label>
                  <div className="input">
                    <p className="mb-25">You can specify randomly</p>
                    <CreatableSelect
                      isMulti
                      name="skill"
                      options={skillsdata}
                      onChange={handleSelect}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      required
                    />
                  </div>
                </div>
                <div className="">
                  <label className="mb-25 d-inline-block font-weight-bolder">
                    Make a request
                  </label>
                  <div className="input">
                    <p className="mb-25">
                      Might include numbers of developers needed and skills
                    </p>
                    <textarea
                      rows="10"
                      onChange={(e) => setOtherDetails(e.target.value)}
                      required></textarea>
                  </div>
                </div>
                <div className="my-2">
                  <button
                    className="d-flex justify-content-center button"
                    type="submit">
                    {hireloading ? <div className="spinner"></div> : "SUBMIT"}
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployerDetailsRequest;
